module.exports = __webpack_public_path__ + "static/media/co-dokaze-mama.626a4186.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/co-dokaze-mama.png
// module id = 428
// module chunks = 0